// extracted by mini-css-extract-plugin
module.exports = {"emailReportStyle":"_2UdY31vW79H2mH5ek62hdD"};